module.exports = __webpack_public_path__ + "static/compliance-d995036919ff1136757bb705a52ddb6e.svg";